import type { TextFeedItem } from "../feedTypes.js";
import type { FeedCardComponentProps } from "../FeedRenderer.js";

interface TextCardProps extends FeedCardComponentProps {
  item: TextFeedItem;
}

const EMPHASIS_CLASS_MAP: Record<NonNullable<TextFeedItem["config"]["emphasis"]>, string> = {
  info: "feed-card-text--info",
  warning: "feed-card-text--warning",
  success: "feed-card-text--success",
  danger: "feed-card-text--danger",
  muted: "feed-card-text--muted"
};

export function TextCard({ item }: TextCardProps) {
  const emphasisClass = item.config.emphasis ? EMPHASIS_CLASS_MAP[item.config.emphasis] : undefined;

  return (
    <div className={emphasisClass ? `feed-card-text ${emphasisClass}` : "feed-card-text"}>
      <p className="feed-card-text-body">{item.config.body}</p>
      {item.config.highlights && item.config.highlights.length > 0 && (
        <ul className="feed-card-highlights">
          {item.config.highlights.map((highlight) => (
            <li key={highlight.label} className="feed-card-highlight">
              {highlight.icon && <span className="feed-card-highlight-icon" aria-hidden>{highlight.icon}</span>}
              <span className="feed-card-highlight-label">{highlight.label}</span>
              {highlight.value && <span className="feed-card-highlight-value">{highlight.value}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
